module.exports = __webpack_public_path__ + "static/img/8.79ff5ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/zh/8.png
// module id = KmFA
// module chunks = 0